import angular from 'angular';
import moment from 'moment-timezone';

module.exports = angular.module('common.filters.years-old', [])
.filter('yearsOld', function() {
  return function(year) {
    if (!year) return;
    return moment().year() - year;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/years-old.js
 **/